import PillButton from "@/app/shared/PillButton";
import { zodResolver } from "@hookform/resolvers/zod";
import Box from "@mui/material/Box";
import { FormProvider, useForm } from "react-hook-form";
import ControlledTextField from "../sell/ad/form/ControlledTextField";
import { useState } from "react";
import { Typography } from "@mui/material";
import {
  CompleteProfileViewModel,
  CompleteProfileViewModelSchema,
} from "@/auth/models/CompleteProfileViewModel";
import { CompleteProfile } from "@/auth/actions/CompleteProfile";

export default function CompleteProfileForm({ userId }: { userId: string }) {
  const [formState, setFormState] = useState<"idle" | "submitting" | "error">(
    "idle"
  );
  const methods = useForm<CompleteProfileViewModel>({
    resolver: zodResolver(CompleteProfileViewModelSchema),
    defaultValues: {
      userId: userId,
      name: "",
      password: "",
    },
  });
  return (
    <FormProvider {...methods}>
      <Box
        component="form"
        onSubmit={methods.handleSubmit(async (data) => {
          try {
            setFormState("submitting");
            await CompleteProfile(data);
            window.location.reload();
          } catch (error) {
            console.error("CLIENT_KNOWN_ERROR: Error completing profile:", error);
            setFormState("error");
          }
        })}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "100%",
          alignItems: "center",
          padding: 4,
        }}
      >
        <Typography>Please complete your profile to continue</Typography>
        <ControlledTextField
          name="name"
          label="Name"
          type="text"
          fullWidth
          autoComplete="name"
        />
        <ControlledTextField
          name="password"
          label="Password (optional)"
          type="password"
          fullWidth
          helpText="or sign in without a password"
          autoComplete="new-password"
        />
        <PillButton
          primary
          type="submit"
          loading={formState === "submitting"}
          disabled={formState === "submitting"}
        >
          Continue
        </PillButton>
        {formState === "error" && (
          <Typography color="error">
            Sorry, something has gone wrong. Please try again later, or contact
            us for support.
          </Typography>
        )}
      </Box>
    </FormProvider>
  );
}
